import BlogGridView from "../../../commonComponents/blogGridView";

const Blog2GridContainer = () => {
  return <BlogGridView gridSize={2} />;
};

export default Blog2GridContainer;
